import { render } from "./opportunities.vue?vue&type=template&id=230e852c"
import script from "./opportunities.vue?vue&type=script&lang=js"
export * from "./opportunities.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nathan/Dev/justcuts-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__